import {OCCUPANCY_STATUSES} from 'ducks/occupancy';

export const removeRevenueSegments = segments => {
  return segments.filter(
    segment =>
      segment.value !== OCCUPANCY_STATUSES.OCCUPIED_BY_EARLY_TERMINATION &&
      segment.value !== OCCUPANCY_STATUSES.OCCUPIED_BY_EARLY_CHECKOUT
  );
};
